import React from 'react';

export function WelcomePanel(props) {
  return (
    <div>
      <h2>
        <span>
          Bem vindo(a)
          {' '}
          {props.name}
          ! Em qual chatbot você deseja realizar curadoria?
        </span>
      </h2>
      <h3>
        Selecione o chatbot escolhido para começar.
      </h3>
    </div>
  );
}

export default WelcomePanel;
